export default __webpack_public_path__ + "static/calidad-de-los-academicos-large-60e5d7ae41b3ebd2228b9fe0d8e67bb4.svg";